var configData = {
    'API_BASE': process.env.REACT_APP_API_URL,
    'SITE_URL': process.env.REACT_APP_SITE_URL,
}

export { configData }